import DOMPurify from "dompurify";

const TRUSTED_EMBED_HOSTS = [
    "www.youtube.com",
    "youtube.com",
    "www.youtube-nocookie.com",
    "player.vimeo.com",
];

/**
 * Sanitiza HTML del blog antes de renderizar (defensa en profundidad).
 */
export function sanitizeBlogHtml(html) {
    if (!html) return "";
    return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ["target", "style"],
        ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
    });
}

/**
 * Valida que una URL de embed sea de YouTube o Vimeo.
 */
export function isTrustedEmbedUrl(url) {
    if (!url || typeof url !== "string") return false;
    try {
        const parsed = new URL(url.trim());
        return TRUSTED_EMBED_HOSTS.some(
            (host) => parsed.hostname === host || parsed.hostname.endsWith(`.${host}`)
        );
    } catch {
        return false;
    }
}
